<template>
  <conferencia-base-dialog
    confirmarLabel="Reprovar"
    :value="value"
    @cancelar="$emit('cancelar')"
    @confirmar="$emit('reprovar', form)"
    @close="$emit('cancelar')"
  >
    <template #title> Deseja realmente reprovar este envelope? </template>
    <template #text>
      <validation-provider name="observacao" rules="required">
        <v-text-field
          class="mb-4"
          v-model="form.observacao"
          label="Observação"
          name="observacao"
          hint="Motivo da reprovação"
          persistent-hint
        />
      </validation-provider>
      <validation-provider name="valor_conferido" rules="required">
        <vuetify-money
          v-model="form.valor_conferido"
          label="Valor Conferido"
          name="valor_conferido"
          type="number"
          hint="Valor real em caixa"
          persistent-hint
          :options="options"
        />
      </validation-provider>
    </template>
  </conferencia-base-dialog>
</template>

<script>
import ConferenciaBaseDialog from './ConferenciaBaseDialog.vue'

export default {
  name: 'ConferenciaReprovar',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  components: { ConferenciaBaseDialog },
  data() {
    return {
      form: {
        observacao: '',
        valor_conferido: '',
      },

      options: {
        locale: 'pt-BR',
        prefix: 'R$',
        suffix: '',
        length: 7,
        precision: 2,
      },
    }
  },
}
</script>
